import React, { useEffect, useState } from "react";
import { languageLabel } from "../../../NewConstants/Language-Constants";
import "./Device_readiness_End.css";
import { generateSpeech } from "../../../Actions/ChatActions";
import { stopPlayingAudio } from "../../../Actions/Utils";
import { description, guideButtons, heading, langPreferenceConstantGuide, secondaryHeading } from "../../../NewConstants/deviceReadinessThankuConstants";

const Device_readiness_End = ({ selectedLanguage, setSelectedLanguage = () => {}, audioRef }) => {
  const [showSpeakerIcon, setShowSpeakerIcon] = useState(false);
  const [showSpeakerActive, setShowSpeakerActive] = useState(false);
  const [requestController, setRequestController] = useState(null);

  useEffect(() => {
    stopPlayingAudio(audioRef);
    window.history.pushState(null, document.title, window.location.href);
    const handlePopState = (event) => {
      window.history.pushState(null, document.title, window.location.href);
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);


  useEffect(() => {
    const handleAudio = async () => {
      const url = await generateSpeech(langPreferenceConstantGuide[selectedLanguage], selectedLanguage);
      const newAudio = new Audio(url);
      if (audioRef.current) {
        audioRef.current.pause();
      }
      if (requestController) {
        requestController.abort();
      }

      audioRef.current = newAudio;
      newAudio.play().catch((err) => {
        console.error("Error playing audio:", err);
      });
    };
    if (showSpeakerActive) handleAudio();
  }, [showSpeakerActive]);


  useEffect(() => {
    const handleVisibilityChange = () => {
      stopPlayingAudio(audioRef);
      setShowSpeakerActive(false);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    }
  }, []);
  
  return (
    <div
      className="bg-[var(--primary-dark-2)] overflow-y-scroll  h-screen w-screen relative bg-blend-color-burn"
      style={{ backgroundImage: `url("/Assets/Images/wallpaperBg.jpg")` }}
    >
      <div className="relative h-full flex flex-col items-center justify-between">
        <div className="w-full  flex justify-end py-7">
            <div 
              className={`speakerDiv ${
                showSpeakerIcon && showSpeakerActive ? "Active" : ""
              }   `}
              onClick={() => {
                setShowSpeakerActive(!showSpeakerActive);
                stopPlayingAudio(audioRef);
              }}
            >
              {showSpeakerIcon && showSpeakerActive ? guideButtons.stop[selectedLanguage] : null}
              {showSpeakerActive ? (
                <div className="pr-6">
                  <img
                    src={"/Assets/Images/blueSpeaker.svg"}
                    alt="active Speaker"
                  />
                </div>
              ) : (
                <div className="pr-6">
                  <img src={"/Assets/Images/crossSpeakerIcon.svg"} alt="speaker" />
                </div>
              )}
            </div>

        </div>

        <div className="align-center items-center py-7">
          <img
            src={"/Assets/Images/asha_icon_square.svg"}
            alt="Asha"
            className="h-[67px] w-[67px]"
          />

        </div>
        <div className="items-center text-center py-4 px-20">
            <div className="text-2xl font-bold color-[var(--neutral-white)] intro-heading">
            {heading[selectedLanguage]}
            </div>
            <div className="text-xs text-white  ">
            {secondaryHeading[selectedLanguage]}
            </div>

        </div>
        <div className="items-center text-center py-6 px-10">
          <div className="text-3xl text-white  font-bold ">
          {description[selectedLanguage]}
              </div>


        </div>


        <div className="flex flex-col text-center py-10  px-[20%]">
          <div className="into-lang-buttons">
            <div
              className={`flex justify-center h-[100%] w-[50%] py-1.5 ${
                selectedLanguage === "hi"
                  ? "introselectedLngBtn"
                  : "intronormalBtn"
              }`}
              onClick={() => setSelectedLanguage("hi")}
            >
              {languageLabel["hi"]}
            </div>
            <div
              className={`flex justify-center h-[100%] w-[50%] py-1.5  ${
                selectedLanguage === "en"
                  ? "introselectedLngBtn"
                  : "intronormalBtn"
              }`}
              onClick={() => setSelectedLanguage("en")}
            >
              {languageLabel["en"]}
            </div>
          </div>
        </div>
        {/* <div>
          <NextBtn
            // value={"Next"}
            value={nextConstant[selectedLanguage]}
            icon={"/Assets/Images/nextBlueIcon.svg"}
            bgColor={"var(--neutral-white)"}
            color={"var(--primary-dark)"}
            nextClick={nextClick}
          />
        </div> */}
        <div className=" h-1/6 flex flex-col align-center items-center bg-[var(--primary-light)] justify-center w-full pb-0">
          <p className="items-center align-center">Powered by</p>
          <img
            src={"/Assets/Images/nhsrc.svg"}
            alt="Asha"
            className="h-[67px] w-[67px]"
          />
        </div>
      </div>
    </div>
  );
};

export default Device_readiness_End;
